// extracted by mini-css-extract-plugin
export var blue = "_1y-h";
export var brand = "_1y-d";
export var darkGrey = "_1y-g";
export var disabled = "_1y-6";
export var disabledSubtle = "_1y-7";
export var error = "_1y-8";
export var green = "_1y-i";
export var grey = "_1y-f";
export var icon = "_1y-0";
export var inherit = "_1y-c";
export var lightGrey = "_1y-e";
export var orange = "_1y-k";
export var pink = "_1y-m";
export var primary = "_1y-1";
export var purple = "_1y-n";
export var quaternary = "_1y-4";
export var quinary = "_1y-5";
export var red = "_1y-l";
export var secondary = "_1y-2";
export var success = "_1y-b";
export var tertiary = "_1y-3";
export var warning = "_1y-9";
export var warningSecondary = "_1y-a";
export var white = "_1y-o";
export var yellow = "_1y-j";